"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.native = native;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

var _auth = _interopRequireDefault(require("./auth"));

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isApp = _utils.default.isApp,
    getSession = _utils.default.getSession,
    getSessionByWeb = _utils.default.getSessionByWeb;
var defaultApiList = ['WLSession', 'WLUser', 'WLPhone', 'WLApp', 'WLWebPV', 'WLTrack', 'WLShare', 'WLRouter', 'WLFile', 'WLNavigation', 'WLNetwork', 'WLNotificationCenter', 'LifeCycleApi', 'WLRefresh', 'WLLocation', 'WLRegion'];
var isInit = false;

function addGlobalFunction() {
  var fn = function fn() {};

  if (!window.pageInvisible) {
    window.pageInvisible = fn;
  }

  if (!window.pageVisible) {
    window.pageVisible = fn;
  }

  if (!window.componentDidMount) {
    window.componentDidMount = fn;
  }
}

function native(_opts) {
  if (isInit) {
    return Promise.reject('重复调用');
  }

  isInit = true;
  addGlobalFunction();
  window.WLSDK = {};
  var def = {
    apiList: defaultApiList,
    config: {
      closeTips: false
    }
  };

  var opts = _objectSpread({}, def, _opts); // 如果app授权方法已注入、或者测试环境网页上打开，直接调初始化


  if (window.WLAuth) {
    return (0, _auth.default)(opts).then(getSession);
  } else if (!isApp()) {
    return getSessionByWeb();
  } else {
    window.WLComponentDidMount = function () {
      window.WLComponentDidMount = function () {};

      return (0, _auth.default)(opts).then(getSession);
    };
  }
}